import styled from 'styled-components';
import Flex from '@decisiv/ui-components/lib/components/Flex';

export const FloatingBar = styled(Flex).attrs({ className: 'if-code' })`
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  align-items: center;
  gap: 1.25rem;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  background-color: var(--if-code-bg);
  box-shadow: 0 4px 12px var(--if-shadow);
`;

export const SelectionCount = styled.span`
  color: var(--if-code-fg);
  font-weight: 600;
  white-space: nowrap;
`;
